import { ICDNCommand } from "../enums/icd-command.enum";

export class ICDCommandBaseModel {
  public icdId: string;
  public cmd: ICDNCommand;
  public data: any;
  constructor(icdId: string, cmd: ICDNCommand, data?: any) {
    this.icdId = icdId;
    this.cmd = cmd;
    this.data = data;
  }
}
